import { Injectable } from '@angular/core';
import { Client } from '@stomp/stompjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationWebSocketService {

	private client?: Client;
	private connectedToken: string | null = null;

	connect(token: string, onMessage: (msg: unknown) => void) {
		if (!token) return;

		if (this.client?.active && token === this.connectedToken) return;

		this.client?.deactivate();
		this.connectedToken = token;

		this.client = new Client({
			brokerURL: `${environment.api.websocket}/ws`,

			connectHeaders: {
				userToken: token
			},

			reconnectDelay: 5000,

			debug: str => console.log('[STOMP]', str),

			onConnect: () => {

				console.log("WS CONNECTED");

				this.client!.subscribe(
					'/user/queue/notifications',
					message => {
						const payload = JSON.parse(message.body);
						onMessage(payload);
					}
				);

			},

			onStompError: frame => {
				console.error("Broker error", frame.headers['message']);
				console.error(frame.body);
			},

			onWebSocketClose: evt => {
				console.warn("WS CLOSED", evt);
			}

		});

		this.client.activate();
	}

	disconnect() {
		this.client?.deactivate();
		this.client = undefined;
		this.connectedToken = null;
	}
}
